import React from "react";
import { Box, Container, Typography, Link, Stack } from "@mui/joy";

const ContactUsPage: React.FC = () => {
  return (
    <Box sx={{ minHeight: '100vh', py: 4, backgroundColor: '#F8F9FA' }}>
      <Container maxWidth="md">
        <Box
          sx={{
            backgroundColor: 'white',
            borderRadius: '16px',
            p: { xs: 3, md: 6 },
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            textAlign: 'center',
          }}
        >
          <Typography
            level="h1"
            sx={{
              fontSize: { xs: "2rem", md: "2.5rem" },
              fontWeight: 600,
              color: "#1A1B1D",
              mb: 3,
            }}
          >
            Contact Us
          </Typography>

          <Typography
            level="body-lg"
            sx={{
              lineHeight: 1.6,
              color: "#7B7F85",
              mb: 4,
              maxWidth: "600px",
              mx: "auto",
            }}
          >
            Have questions or need assistance? We're here to help! 
            Get in touch with the Geek team using the contact information below.
          </Typography>

          <Stack 
            spacing={3} 
            sx={{ 
              maxWidth: "400px", 
              mx: "auto",
              alignItems: "center" 
            }}
          >
            {/* Phone Contact */}
            <Box
              sx={{
                p: 3,
                borderRadius: "12px",
                backgroundColor: "#F8F9FA",
                border: "1px solid #E5E7EB",
                width: "100%",
              }}
            >
              <Typography
                level="h3"
                sx={{
                  fontSize: "1.25rem",
                  fontWeight: 600,
                  color: "#1A1B1D",
                  mb: 1,
                }}
              >
                Phone
              </Typography>
              <Link
                href="tel:+13233131805"
                sx={{
                  fontSize: "1.125rem",
                  color: "#2E2D7E",
                  fontWeight: 600,
                  textDecoration: "none",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                323-313-1805
              </Link>
            </Box>

            {/* Email Contact */}
            <Box
              sx={{
                p: 3,
                borderRadius: "12px",
                backgroundColor: "#F8F9FA",
                border: "1px solid #E5E7EB",
                width: "100%",
              }}
            >
              <Typography
                level="h3"
                sx={{
                  fontSize: "1.25rem",
                  fontWeight: 600,
                  color: "#1A1B1D",
                  mb: 1,
                }}
              >
                Email
              </Typography>
              <Link
                href="mailto:dalton@geekapp.co"
                sx={{
                  fontSize: "1.125rem",
                  color: "#2E2D7E",
                  fontWeight: 600,
                  textDecoration: "none",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                dalton@geekapp.co
              </Link>
            </Box>
          </Stack>

          <Typography
            level="body-md"
            sx={{
              lineHeight: 1.6,
              color: "#7B7F85",
              mt: 4,
              maxWidth: "500px",
              mx: "auto",
            }}
          >
            We respond to all inquiries in the order in which they are received. 
            For urgent matters, please call us directly.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default ContactUsPage;
